import { VENDOR_PROFILE, VENUE_PROFILE } from 'constants/Profiles';

const getProfileType = profile => (profile?.venue ? VENUE_PROFILE : VENDOR_PROFILE);

export default getProfileType;
